import { createSlice } from "@reduxjs/toolkit";
import { stateEnum } from "../constants/enum";

const { shade } = stateEnum;

let initialState = {
    detailParams: {},
    isNewEntry: false
};


const shadeSlice = createSlice({
    name: shade,
    initialState,
    reducers: {
        setNewEntryMode: (state, action) => {
            state.isNewEntry = action.payload;
        },
        setDetailParams: (state, action) => {
            state.detailParams = action.payload
          },
        resetDetail: (state) => {
            state.detailParams = {};
            state.isNewEntry = true;
        },
    },
    
});


export const { setNewEntryMode,setDetailParams, resetDetail } = shadeSlice.actions;
export default shadeSlice.reducer;
